import { ChangeDetectorRef, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable, catchError, map, of } from 'rxjs';
import { GoogleAuthProvider } from 'firebase/auth';
// import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Router } from '@angular/router';
import Cookies from 'universal-cookie';
// import { Observable } from 'rxjs';

@Injectable({
  providedIn: "root",
})
export class AuthService {
  constructor(
    private http: HttpClient,
    // public afAuth: AngularFireAuth,
    private router: Router
  ) {}

  user = undefined;

  userSubject = new BehaviorSubject(this.user);

  signIn = (requestPayload) =>
    this.http.post(`${environment.BASE_URL}/auth/login`, requestPayload);

  signUp = (requestPayload) =>
    this.http.post(`${environment.BASE_URL}/users/usersignup`, requestPayload);

  validateOTP = (payload) =>
    this.http.post(`${environment.BASE_URL}/users/validate-otp`, payload);

  sendOTP = (payload) =>
    this.http.post(`${environment.BASE_URL}/users/resendotp`, payload);
  getUserByID = (id) =>
    this.http.get(`${environment.BASE_URL}/users/getuser${id}`);
  getIndustries = () =>
    this.http.get(`${environment.BASE_URL}/vendor/industryType`);

  forgotPassword = (requestPayload) =>
    this.http.post(
      `${environment.BASE_URL}/auth/forgot-password`,
      requestPayload
    );
  onboardingVendor = (requestPayload) =>
    this.http.put(
      `${environment.BASE_URL}/vendor/user/company-details`,
      requestPayload
    );

  resetPassword = (requestPayload, token) => {
    let params = new HttpParams();
    params = params.append("token", token);
    return this.http.post(
      `${environment.BASE_URL}/auth/reset-password`,
      requestPayload,
      { params }
    );
  };

  updateInfo = (requestpayload) =>
    this.http.put(`${environment.BASE_URL}/users/update-info`, requestpayload);

  updatePassword = (requestpayload) =>
    this.http.put(
      `${environment.BASE_URL}/users/update-password`,
      requestpayload
    );

  contactUs = (requestpayload) =>
    this.http.post(`${environment.BASE_URL}/auth/contact-us`, requestpayload);

  // public logout = () => {
  //   localStorage.removeItem("i-token");
  //   localStorage.removeItem("i-user");
  //   localStorage.removeItem("i-refresh");
  //   this.router.navigate(["/auth/login"]);
  // };

  refreshToken(): Observable<string | null> {
    const refreshToken = localStorage.getItem("i-refresh");

    if (!refreshToken) {
      return of(null);
    }

    return this.http
      .post<any>(`${environment.BASE_URL}/auth/refresh-token`, {
        refresh_token: refreshToken,
      })
      .pipe(
        map((response) => {
          const newToken = response.access_token;
          localStorage.setItem("i-token", newToken);
          return newToken;
        }),
        catchError((err) => {
          this.logout();
          return of(null);
        })
      );
  }

  updateProfile = (requestPayload) =>
    this.http.put(
      `${environment.BASE_URL}/auth-service/vendor/update-profile`,
      requestPayload
    );

  editProfile = (requestPayload) =>
    this.http.put(
      `${environment.BASE_URL}/auth-service/vendor/edit-profile`,
      requestPayload
    );

  deleteProfilePicture = () =>
    this.http.delete(
      `${environment.BASE_URL}/auth-service/vendor/profile-picture`
    );

  changePassword = (requestPayload) =>
    this.http.post(
      `${environment.BASE_URL}/auth-service/vendor/change-password`,
      requestPayload
    );

  updateKYC = (requestPayload) =>
    this.http.put(
      `${environment.BASE_URL}/auth-service/vendor/update-kyc`,
      requestPayload
    );

  // getUser = () => JSON.parse(localStorage.getItem("i-user"));

  // Sign in with Google
  // GoogleAuth() {
  //   return this.AuthLogin(new GoogleAuthProvider());
  // }
  // Auth logic to run auth providers
  // AuthLogin(provider) {
  //   return this.afAuth
  //     .signInWithPopup(provider)
  //     .then((result) => {
  //       return result
  //     })
  //     .catch((error) => {
  //       return error
  //     });
  // }

  public storeRedirectUrl(url: string): void {
    localStorage.setItem('IRedirectUrl', url);
  }

  public getRedirectUrl(): string | null {
    return localStorage.getItem('IRedirectUrl');
  }

  public removeRedirectUrl(): void {
    localStorage.removeItem('IRedirectUrl');
  }


  private cookies = new Cookies();
  // setAuthData(accessToken: string, refreshToken: string, user: any) {
  //   const expiresDate = new Date();
  //   expiresDate.setDate(expiresDate.getDate() + 7);

  //   const isLocalhost = window.location.hostname === 'localhost';
  //   const prodDomain = '.invitte.app'
  //   this.cookies.set('i-token', accessToken, {
  //     path: '/',
  //     domain: isLocalhost ? 'localhost' : prodDomain,
  //     secure: !isLocalhost,
  //     sameSite: isLocalhost ? 'lax' : 'none',
  //     expires: expiresDate
  //   });

  //   this.cookies.set('i-refresh', refreshToken, {
  //     path: '/',
  //     domain: isLocalhost ? 'localhost' : prodDomain,
  //     secure: !isLocalhost,
  //     sameSite: isLocalhost ? 'lax' : 'none',
  //     expires: expiresDate
  //   });

  //   this.cookies.set('i-user', JSON.stringify(user), {
  //     path: '/',
  //     domain: isLocalhost ? 'localhost' : prodDomain,
  //     secure: !isLocalhost,
  //     sameSite: isLocalhost ? 'lax' : 'none',
  //     expires: expiresDate
  //   });
  // }

  setAuthData(accessToken: string, refreshToken: string, user: any) {
    const expiresDate = new Date();
    expiresDate.setDate(expiresDate.getDate() + 7);

    const hostname = window.location.hostname;
    const isLocalhost = hostname === 'localhost';
    const isSandbox = hostname.includes('invitte.nw.r.appspot.com') || hostname.includes('vendor-app-dot-invitte.nw.r.appspot.com');
    const prodDomain = '.invitte.app';
    const sandboxDomain = '.nw.r.appspot.com';

    const domain = isLocalhost ? 'localhost' : isSandbox ? sandboxDomain : prodDomain;

    this.cookies.set('i-token', accessToken, {
      path: '/',
      domain,
      secure: !isLocalhost,
      sameSite: isLocalhost ? 'lax' : 'none',
      expires: expiresDate
    });

    this.cookies.set('i-refresh', refreshToken, {
      path: '/',
      domain,
      secure: !isLocalhost,
      sameSite: isLocalhost ? 'lax' : 'none',
      expires: expiresDate
    });

    this.cookies.set('i-user', JSON.stringify(user), {
      path: '/',
      domain,
      secure: !isLocalhost,
      sameSite: isLocalhost ? 'lax' : 'none',
      expires: expiresDate
    });
  }

  logout() {
    const hostname = window.location.hostname;
    const isLocalhost = hostname === 'localhost';
    const isSandbox = hostname.includes('invitte.nw.r.appspot.com') || hostname.includes('vendor-app-dot-invitte.nw.r.appspot.com');
    const prodDomain = '.invitte.app';
    const sandboxDomain = '.nw.r.appspot.com';

    const domain = isLocalhost ? 'localhost' : isSandbox ? sandboxDomain : prodDomain;

    this.cookies.remove('i-token', { path: '/', domain });
    this.cookies.remove('i-refresh', { path: '/', domain });
    this.cookies.remove('i-user', { path: '/', domain });

    this.router.navigate(['/auth/login']);
  }
  getAccessToken(): string | null {
    const token = this.cookies.get('i-token');
    return token || null;
  }

  getRefreshToken(): string | null {
    const refreshToken = this.cookies.get('i-refresh');
    return refreshToken || null;
  }

  getUser(): any {
    const user = this.cookies.get('i-user');
    return user || null;
  }

  // logout() {
  //   const isLocalhost = window.location.hostname === 'localhost';
  //   const prodDomain = '.invitte.app'
  //   this.cookies.remove('i-token', { path: '/', domain: isLocalhost ? 'localhost' : prodDomain });
  //   this.cookies.remove('i-refresh', { path: '/', domain: isLocalhost ? 'localhost' : prodDomain });
  //   this.cookies.remove('i-user', { path: '/', domain: isLocalhost ? 'localhost' : prodDomain });
  //   this.router.navigate(['/auth/login'])
  // }

}
